<script setup lang="ts">
interface Props {
  type: 'no-data' | 'no-results' | 'no-pursuits' | 'error'
  title: string
  description?: string
  actionLabel?: string
}
defineProps<Props>()
const emit = defineEmits<{ action: [] }>()
</script>

<template>
  <div class="empty-illu">
    <svg v-if="type === 'no-data'" data-variant="no-data" viewBox="0 0 120 120" width="120" height="120">
      <rect x="20" y="40" width="80" height="60" rx="6" fill="none" stroke="var(--line)" stroke-width="2"/>
      <path d="M20 50 L60 30 L100 50" fill="none" stroke="var(--muted)" stroke-width="2" stroke-linejoin="round"/>
      <circle cx="60" cy="75" r="3" fill="var(--muted-2)"/>
    </svg>
    <svg v-else-if="type === 'no-results'" data-variant="no-results" viewBox="0 0 120 120" width="120" height="120">
      <circle cx="55" cy="55" r="28" fill="none" stroke="var(--line)" stroke-width="3"/>
      <line x1="75" y1="75" x2="95" y2="95" stroke="var(--muted)" stroke-width="4" stroke-linecap="round"/>
      <text x="55" y="63" text-anchor="middle" font-size="22" fill="var(--muted-2)" font-family="Inter, sans-serif">?</text>
    </svg>
    <svg v-else-if="type === 'no-pursuits'" data-variant="no-pursuits" viewBox="0 0 120 120" width="120" height="120">
      <circle cx="60" cy="60" r="40" fill="var(--ok-soft)"/>
      <path d="M44 62 L56 74 L78 50" fill="none" stroke="var(--ok)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg v-else data-variant="error" viewBox="0 0 120 120" width="120" height="120">
      <path d="M60 24 L100 92 L20 92 Z" fill="var(--danger-soft)" stroke="var(--danger)" stroke-width="2" stroke-linejoin="round"/>
      <line x1="60" y1="48" x2="60" y2="72" stroke="var(--danger)" stroke-width="4" stroke-linecap="round"/>
      <circle cx="60" cy="82" r="3" fill="var(--danger)"/>
    </svg>

    <h3 class="empty-title">{{ title }}</h3>
    <p v-if="description" class="empty-desc">{{ description }}</p>
    <button
      v-if="actionLabel"
      type="button"
      class="empty-action"
      data-test="action"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<style scoped>
.empty-illu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--sp-6) var(--sp-4);
  color: var(--ink-2);
  gap: var(--sp-2);
}
.empty-title { margin: var(--sp-3) 0 0; font-size: var(--fs-md); font-weight: 600; color: var(--ink); }
.empty-desc  { margin: 0; font-size: var(--fs-sm); color: var(--muted); max-width: 340px; }
.empty-action {
  margin-top: var(--sp-3);
  background: var(--accent);
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: var(--r-ctrl);
  font-size: var(--fs-13);
  cursor: pointer;
  transition: background 120ms;
}
.empty-action:hover { background: var(--accent-2); }
</style>
